import React, { FC, ReactNode } from 'react';
import { Icon } from '@routific/hive';

type IconProps = Partial<React.ComponentProps<typeof Icon>>;

interface IconWrapperProps extends IconProps {
  children?: ReactNode;
}

const IconWrapper: FC<IconWrapperProps> = ({ children, type, size = 'small', className, ...rest }) => {
  const classNames = ['hive-icon', `hive-icon-${size}`, `hive-icon-type-${type}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};

export default IconWrapper;
